import React, {useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import {setRemindersShow, setUserRemindersData,} from "../store/reducers/listingReducer";
import {config} from "../config";
import {markReminderRead, removeReminder} from "../services/api";
import {useNavigate} from "react-router-dom";
import {Table} from "./ui/Table";
import {createColumnHelper, getCoreRowModel, useReactTable,} from "@tanstack/react-table";

interface IProps {
}

export const Reminders = (props: IProps) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const logged = useSelector((state: any) => state.listingReducer.logged);
    const userReminders = useSelector(
        (state: any) => state.listingReducer.userReminders
    );

    function handleReminders() {
        dispatch(setRemindersShow(false));
    }

    function removeItemByListingUniqueId(listingUniqueId: string) {
        // Use Array.prototype.filter to create a new array without the target item
        return userReminders.filter(
            (item: any) => item.listing_unique_id !== listingUniqueId
        );
    }

    async function handleDelete(listingUniqueId: string) {
        let params: any = {};
        params["listing_unique_id"] = listingUniqueId;
        let result = await removeReminder(params);
        if (!result?.data.success) {
            return;
        }
        let newReminders = removeItemByListingUniqueId(listingUniqueId);
        dispatch(setUserRemindersData(newReminders));
    }

    async function handleMarkRead(listingUniqueId: string) {
        let params: any = {};
        params["listing_unique_id"] = listingUniqueId;
        let result = await markReminderRead(params);
        if (!result?.data.success) {
            return;
        }
        const newReminders = userReminders.map((reminder: any) => {
            if (reminder.listing_unique_id === listingUniqueId) {
                return {...reminder, user_read: "1"};
            }
            return reminder;
        });

        dispatch(setUserRemindersData(newReminders));

        navigate(config.path + listingUniqueId);
        dispatch(setRemindersShow(false));
    }

    const columnHelper = createColumnHelper<any>();

    const columns = useMemo(
        () => [
            columnHelper.accessor("reminder_title", {
                cell: (info) => info.getValue(),
                header: "Title",
            }),
            columnHelper.accessor("listing_address", {
                cell: (info) => info.getValue(),
                header: "Address",
            }),
            columnHelper.display({
                id: "action",
                cell(props) {
                    return (
                        <div className="font-semibold space-x-3">
                            <button
                                onClick={() =>
                                    handleMarkRead(props.row.original.listing_unique_id)
                                }
                                className="text-blue-600"
                            >
                                View
                            </button>
                            <button
                                onClick={() =>
                                    handleDelete(props.row.original.listing_unique_id)
                                }
                                className="text-red-600"
                            >
                                Delete
                            </button>
                        </div>
                    );
                },
            }),
        ],
        [columnHelper]
    );

    const table = useReactTable({
        columns,
        data: userReminders,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <div className="w-full p-6">
            <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold text-gray-900">Reminders</h3>
                <button onClick={() => navigate("/")} className="h-10 w-10">
                    <FontAwesomeIcon icon={faXmark}/>
                </button>
            </div>

            <div className="mt-6">
                <div className="mt-5">
                    <Table heading={table.getHeaderGroups()} body={table.getRowModel()}/>
                </div>
            </div>
        </div>
    );

    // return (
    //     <div className="sidebar-section reminders">
    //         <h1>My Reminders</h1>
    //         <div className={"user-reminders-close"}>
    //             <a onClick={handleReminders} href="#"
    //                className="btn btn-primary btn-small btn-rounded icon shadow import-listing">
    //                 <FontAwesomeIcon icon={faClose}/><span></span></a>
    //         </div>
    //         <div className={"user-reminders-container"}>
    //             {userReminders.map((reminder: any) => (
    //                 <div className={reminder.user_read === '0' ? 'unread user-reminders-item' : 'user-reminders-item'}
    //                      key={'user-reminders-' + reminder.public_id}>
    //                     <div className={"user-reminders-head"}>
    //                         <div className={'user-reminders-info'}>
    //                             <div className={"user-reminders-name"}>
    //                                 {reminder.reminder_title}
    //                             </div>
    //                             <div className={"user-reminders-address"}>
    //                                 {reminder.listing_address}
    //                             </div>
    //                         </div>

    //                         <div className={"user-reminders-view"}>
    //                             <Button variant="primary" type={'submit'} onClick={(event) => {
    //                                 event.preventDefault();
    //                                 handleMarkRead(reminder.listing_unique_id);
    //                             }}>
    //                                 View
    //                             </Button>
    //                         </div>
    //                         <div className={"user-reminders-delete"}>
    //                             <Button variant="primary" type={'submit'} onClick={(event) => {
    //                                 event.preventDefault();
    //                                 handleDelete(reminder.listing_unique_id);
    //                             }}>
    //                                 Delete
    //                             </Button>
    //                         </div>
    //                     </div>
    //                 </div>
    //             ))}

    //         </div>
    //     </div>

    // );
};
export default Reminders;
